import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSSpacing } from '../spacing/index.esm.js';
import styles from '../../styles/uitk-egds-spacing.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSSpacingHr = props => {
  const {
    blockMargin = 'four'
  } = props;
  const baseClass = 'uitk-spacing-hr';
  return jsx(EGDSSpacing, {
    border: ['blockstart'],
    className: getClassNameList(baseClass),
    margin: {
      block: blockMargin
    },
    children: jsx("hr", {})
  });
};
export { EGDSSpacingHr };